import React from 'react'

const AppRegionDrag: React.FC = () => (
  <div className="h-5 app-region-drag absolute top-0 left-0 right-0 pointer-events-none z-0" />
)

export {AppRegionDrag}
